export const epidemiologico2024 = [
  {
    "id_semana":"Semana 1 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 1.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 1.png",
  },
  {
    "id_semana":"Semana 2 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 2.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 2.png",
  },
  {
    "id_semana":"Semana 3 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 3.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 3.png",
  },
  {
    "id_semana":"Semana 4 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 4.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 4.png",
  },
  {
    "id_semana":"Semana 5 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 5.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 5.png",
  },
  {
    "id_semana":"Semana 6 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 6.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 6.png",
  },
  {
    "id_semana":"Semana 7 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 7.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 7.png",
  },
  {
    "id_semana":"Semana 8 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 8.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 8.png",
  },
  {
    "id_semana":"Semana 9 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 9.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 9.png",
  },
  {
    "id_semana":"Semana 10 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 10.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 10.png",
  },
  {
    "id_semana":"Semana 11 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 11.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 11.png",
  },
  {
    "id_semana":"Semana 12 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 12.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 12.png",
  },
  {
    "id_semana":"Semana 13 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 13.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 13.png",
  },
  {
    "id_semana":"Semana 14 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 14.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 14.png",
  },
  {
    "id_semana":"Semana 15 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 15.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 15.png",
  },
  {
    "id_semana":"Semana 16 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 16.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 16.png",
  },
  {
    "id_semana":"Semana 17 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 17.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 17.png",
  },
  {
    "id_semana":"Semana 18 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 18.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 18.png",
  },
  {
    "id_semana":"Semana 19 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 19.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 19.png",
  },
  {
    "id_semana":"Semana 20 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 20.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 20.png",
  },
  {
    "id_semana":"Semana 21 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 21.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 21.png",
  },
  {
    "id_semana":"Semana 22 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 22.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 22.png",
  },
  {
    "id_semana":"Semana 23 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 23.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 23.png",
  },
  {
    "id_semana":"Semana 24 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 24.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 24.png",
  },
  {
    "id_semana":"Semana 25 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 25.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 25.png",
  },
  {
    "id_semana":"Semana 26 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 26.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 26.png",
  },
  {
    "id_semana":"Semana 27 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 27.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 27.png",
  },
  {
    "id_semana":"Semana 28 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 28.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 28.png",
  },
  {
    "id_semana":"Semana 29 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 29.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 29.png",
  },
  {
    "id_semana":"Semana 30 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 30.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 30.png",
  },
  {
    "id_semana":"Semana 31 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 31.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 31.png",
  },
  {
    "id_semana":"Semana 32 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 32.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 32.png",
  },
  {
    "id_semana":"Semana 33 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 33.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 33.png",
  },
  {
    "id_semana":"Semana 34 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 34.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 34.png",
  },
  {
    "id_semana":"Semana 35 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 35.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 35.png",
  },
  {
    "id_semana":"Semana 36 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 36.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 36.png",
  },
  {
    "id_semana":"Semana 37 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 37.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 37.png",
  },
  {
    "id_semana":"Semana 38 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 38.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 38.png",
  },
  {
    "id_semana":"Semana 39 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 39.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 39.png",
  },
  {
    "id_semana":"Semana 40 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 40.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 40.png",
  },
  {
    "id_semana":"Semana 41 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 41.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 41.png",
  },
  {
    "id_semana":"Semana 42 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 42.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 42.png",
  },
  {
    "id_semana":"Semana 43 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 43.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 43.png",
  },
  {
    "id_semana":"Semana 44 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 44.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 44.png",
  },
  {
    "id_semana":"Semana 45 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 45.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 45.png",
  },
  {
    "id_semana":"Semana 46 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 46.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 46.png",
  },
  {
    "id_semana":"Semana 47 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 47.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 47.png",
  },
  {
    "id_semana":"Semana 48 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 48.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 48.png",
  },
  {
    "id_semana":"Semana 49 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 49.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 49.png",
  },
  {
    "id_semana":"Semana 50 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 50.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 50.png",
  },
  {
    "id_semana":"Semana 51 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 51.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 51.png",
  },
  {
    "id_semana":"Semana 52 - 2024",
    "file_url": "../../contenido/epidemiologia/2024/Boletin Semana 52.pdf",
    "img_url":"../../../contenido/epidemiologia/2024/Boletin Semana 52.png",
  },
]